import React from "react";
import { Grid, Typography, Button } from "@mui/material";
import ButtonImg from "../../assets/monitor.png";
import { Container } from "@mui/material";

import "../header/index.css";
export default function header() {
  return (
    <>
      <Container className="header-max-container">
        <Grid container className="header-container">
          <Grid item>
            <Typography className="terra-treasury-text">
              TERRA TREASURY
            </Typography>
          </Grid>
          <Grid item className="dashboard-develper-text">
            <Typography className="terra-treasury-text-1">DASHBOARD</Typography>
            <Typography className="terra-treasury-text-2">DEVELPERS</Typography>
            <Grid item>
              <Button className="header-button">
                <img src={ButtonImg} />
                <Typography className="header-button-text">WebApp</Typography>
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
